module.exports = __webpack_public_path__ + "static/assets/b3140fa2904f62dfa70e7327c88422b4.gif";